import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';

class PolicyEndorsementProvider {

    constructor() {
        this.paths          = URLConfiguration.paths;
        this.apiProvider    = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
    }

    getValidarEndosoPoliza = async (validarEndosoPoliza) => {
        const headers   = HeadersMapping.getHeaderService();
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.poliza.validaEndosoPoliza, validarEndosoPoliza);
        let response    = null;
        try {
            response = await this.apiProvider.get(pathNew, { headers });
        } catch (error) {
            console.log(error);
        }
        return response
    }

}

export default PolicyEndorsementProvider;